module.exports = {
    baseUrl: "https://backend-info-ducthanh-2.onrender.com",
    // baseUrl: "http://127.0.0.1:3005",
};
